'use client';

import { createContext, useContext, useEffect, useState } from 'react';

import { fetchContent } from '@/lib/fetch-content';
import type { ContentWrapperDto } from '@/types/content';

type HeaderMenuContentValue = {
  content: ContentWrapperDto | null;
  contentLoading: boolean;
  contentError: boolean;
};

const defaultValue: HeaderMenuContentValue = {
  content: null,
  contentLoading: true,
  contentError: false,
};

const HeaderMenuContentContext = createContext<HeaderMenuContentValue>(defaultValue);

export function HeaderMenuContentProvider({ children }: { children: React.ReactNode }) {
  const [value, setValue] = useState<HeaderMenuContentValue>(defaultValue);

  useEffect(() => {
    let cancelled = false;

    fetchContent()
      .then((data) => {
        if (cancelled) return;
        setValue({
          content: data,
          contentLoading: false,
          contentError: !data,
        });
      })
      .catch(() => {
        if (cancelled) return;
        setValue({ content: null, contentLoading: false, contentError: true });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return <HeaderMenuContentContext.Provider value={value}>{children}</HeaderMenuContentContext.Provider>;
}

export function useHeaderMenuContent() {
  return useContext(HeaderMenuContentContext);
}
